import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import { api } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Send } from "lucide-react";

export default function Messages() {
  const [threads, setThreads] = useState([]);
  const [active, setActive] = useState(null);
  const [data, setData] = useState(null);
  const [body, setBody] = useState("");

  const loadThreads = async () => {
    const { data } = await api.get("/messages/threads");
    setThreads(data);
    if (!active && data.length > 0) setActive(data[0].id);
  };
  const loadThread = async (id) => {
    const { data } = await api.get(`/messages/threads/${id}`);
    setData(data);
  };

  useEffect(() => { loadThreads(); }, []);
  useEffect(() => { if (active) loadThread(active); }, [active]);

  const send = async () => {
    if (!body.trim() || !active) return;
    await api.post("/messages", { thread_id: active, body });
    setBody("");
    loadThread(active);
    loadThreads();
  };

  return (
    <div className="min-h-screen bg-[#F8F9FE]">
      <Navbar />
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-10">
        <div className="label-eyebrow mb-2">Messages</div>
        <h1 className="font-display text-4xl font-bold tracking-tight">Inbox</h1>

        <div className="mt-8 grid lg:grid-cols-12 gap-4 h-[600px]">
          <aside className="lg:col-span-4 bg-white border border-[#E4E7F5] rounded-md overflow-y-auto">
            {threads.length === 0 && <div className="p-6 text-sm text-[#5B6478]">No conversations yet</div>}
            {threads.map((t) => (
              <button
                key={t.id}
                data-testid={`thread-${t.id}`}
                onClick={() => setActive(t.id)}
                className={`w-full text-left p-4 border-b border-[#E4E7F5] hover:bg-[#EEF0FA] ${active === t.id ? "bg-[#EEF0FA]" : ""}`}
              >
                <div className="font-display font-semibold">{t.other_name}</div>
                <div className="text-xs text-[#5B6478] mt-1">{new Date(t.last_message_at).toLocaleString()}</div>
              </button>
            ))}
          </aside>
          <main className="lg:col-span-8 bg-white border border-[#E4E7F5] rounded-md flex flex-col">
            {data ? (
              <>
                <div className="p-4 border-b border-[#E4E7F5] font-display font-bold">{data.thread.participant_names[data.thread.participants.find((p) => p !== JSON.parse(localStorage.getItem("esb_user")).id)]}</div>
                <div className="flex-1 overflow-y-auto p-4 space-y-3">
                  {data.messages.map((m) => {
                    const me = m.sender_id === JSON.parse(localStorage.getItem("esb_user")).id;
                    return (
                      <div key={m.id} className={`flex ${me ? "justify-end" : "justify-start"}`}>
                        <div className={`max-w-[70%] rounded-md px-4 py-2 ${me ? "bg-[#1E3A8A] text-[#F8F9FE]" : "bg-[#EEF0FA] text-[#0F1E4B]"}`}>
                          <div className="text-sm">{m.body}</div>
                          <div className={`text-[10px] mt-1 ${me ? "text-[#F8F9FE]/70" : "text-[#5B6478]"}`}>{new Date(m.created_at).toLocaleTimeString()}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="p-3 border-t border-[#E4E7F5] flex gap-2">
                  <Input data-testid="msg-input" value={body} onChange={(e) => setBody(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} placeholder="Type a message..." className="border-[#E4E7F5]" />
                  <Button data-testid="msg-send" onClick={send} className="bg-[#1E3A8A] hover:bg-[#2E4FB8] text-[#F8F9FE]">
                    <Send className="w-4 h-4" />
                  </Button>
                </div>
              </>
            ) : (
              <div className="flex-1 flex items-center justify-center text-[#5B6478]">Select a conversation</div>
            )}
          </main>
        </div>
      </div>
    </div>
  );
}
